import React from "react"
import { useSearchspringSuggestContext } from "@app/scripts/providers/searchspring"
import { useSearchspringTrendingContext } from "@app/scripts/providers/searchspring"

export function SearchDrawerMenu({
  showNoResults,
  title,
  noResults,
  provider,
}: {
  showNoResults?: boolean
  title?: string
  noResults?: string
  provider?: string
}) {
  const trendingContext = useSearchspringTrendingContext()
  const suggestContext = useSearchspringSuggestContext()

  const response =
    provider === "trending"
      ? trendingContext.response?.trending?.queries
      : provider === "suggest"
        ? suggestContext?.response?.suggested?.completed
        : []

  return (
    <div className="search-drawer--menu-container">
      {showNoResults ? (
        <p className="search-drawer--menu-no-results">{noResults}</p>
      ) : (
        <>
          <h3 className="search-drawer--menu-title">{title}</h3>
          <div className="search-drawer--menu-items-container">
            {response?.map((item, index) => (
              <a
                key={index}
                href={`/search?query=${item?.searchQuery || item}`}
                className="search-drawer--menu-item"
              >
                {item?.searchQuery || item}
                <span className="search-drawer--menu-item-underline"></span>
              </a>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
